import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.irReasons.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.irReasons.actionsLoading;
export const getItems = (state:RootState) => state.irReasons.items;
export const getItemsSelect = (state:RootState) => state.irReasons.dropDownItems;
export const getItemsCount = (state:RootState) => state.irReasons.itemsCount;
export const getItemForEdit = (state:RootState) => state.irReasons.itemForEdit;
export const getError = (state:RootState) => state.irReasons.error;
export const getErrorAction = (state:RootState) => state.irReasons.errorAction;
export const validationErrors = (state: RootState) => state.irReasons.validationErrors;
